import type { Caps, PlayableItem, PlayerKind } from "../types";

/** Every capability off: a kind turns on only what it does. */
export const NO_CAPS: Caps = {
  seekable: false, live: false, endsByItself: false, heldWhenHidden: false, castable: false,
  queueable: false, dockable: false, gallery: false, fullScreen: false, ownControls: false, nothingOver: false,
};

type KindSpec = Omit<PlayerKind, "caps" | "matches" | "canPlay" | "playUrl" | "sourceUrl" | "queueReady" | "provider" | "slot" | "typeLabel" | "meta"> &
  Partial<Pick<PlayerKind, "matches" | "canPlay" | "playUrl" | "sourceUrl" | "queueReady" | "provider" | "slot" | "typeLabel" | "meta">> & {
    caps: Partial<Caps>;
  };

const urlOf = (item: PlayableItem): string | null => item.url || null;

/**
 * A registry entry with the common defaults: plays its `url`, queues it when the type is queueable; `meta` defaults to
 * `label`, `typeLabel` to `meta`.
 */
export function defineKind(spec: KindSpec): PlayerKind {
  const caps = { ...NO_CAPS, ...spec.caps };
  const meta = spec.meta ?? spec.label;
  return {
    provider: null,
    slot: null,
    matches: () => true,
    canPlay: () => true,
    playUrl: urlOf,
    sourceUrl: urlOf,
    queueReady: () => caps.queueable,
    meta,
    typeLabel: meta,
    ...spec,
    caps,
  };
}
